import * as Types from '../../generated.types'

import { TelephoneFragmentDoc } from '../../fragments/TelephoneFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never }>

export type CurrentUserQuery = {
  __typename?: 'Query'
  currentUser?: {
    __typename?: 'User'
    id: number
    firstName?: string | null
    lastName?: string | null
    preferredName?: string | null
    email?: string | null
    languagePreference: Types.LanguagePreference
    birthdate?: string | null
    isEmailConfirmed: boolean
    hasDummyPassword: boolean
    helpScoutSecureBeaconToken?: string | null
    access: { __typename?: 'FeatureAccess'; orgAdminDashboard: Types.AccessRequirementEnum }
    tel?: {
      __typename?: 'Telephone'
      nationalNumber: string
      isSmsConfirmed?: boolean | null
      isConfirmationCodeSent?: boolean | null
    } | null
    provisionalOrganizations: Array<{ __typename?: 'ProvisionalOrganization'; id: number }>
    roles: Array<{ __typename?: 'Role'; id: number }>
  } | null
}

export type GqlUserFragment = {
  __typename?: 'User'
  id: number
  firstName?: string | null
  lastName?: string | null
  preferredName?: string | null
  email?: string | null
  languagePreference: Types.LanguagePreference
  birthdate?: string | null
  isEmailConfirmed: boolean
  hasDummyPassword: boolean
  helpScoutSecureBeaconToken?: string | null
  access: { __typename?: 'FeatureAccess'; orgAdminDashboard: Types.AccessRequirementEnum }
  tel?: {
    __typename?: 'Telephone'
    nationalNumber: string
    isSmsConfirmed?: boolean | null
    isConfirmationCodeSent?: boolean | null
  } | null
  provisionalOrganizations: Array<{ __typename?: 'ProvisionalOrganization'; id: number }>
  roles: Array<{ __typename?: 'Role'; id: number }>
}

export const GqlUserFragmentDoc = `
    fragment GqlUser on User {
  id
  access {
    orgAdminDashboard
  }
  firstName
  lastName
  preferredName
  email
  languagePreference
  birthdate
  isEmailConfirmed
  hasDummyPassword
  tel {
    ...Telephone
  }
  helpScoutSecureBeaconToken
  provisionalOrganizations {
    id
  }
  roles(roleType: OrganizationRole) {
    id
  }
}
    `
export const CurrentUserDocument = `
    query CurrentUser {
  currentUser {
    ...GqlUser
  }
}
    ${GqlUserFragmentDoc}
${TelephoneFragmentDoc}`
export const useCurrentUserQuery = <TData = CurrentUserQuery, TError = Error>(
  variables?: CurrentUserQueryVariables,
  options?: UseQueryOptions<CurrentUserQuery, TError, TData>
) =>
  useQuery<CurrentUserQuery, TError, TData>(
    variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
    fetchGql<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables),
    options
  )

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) =>
  variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables]
